/**
 * 储值缴费
 *  */
export const MERBERCARPUBLICQUERY = "MERBERCARPUBLICQUERY"  // 我的车辆列表
export const RESETSTOREDDATA = "RESETSTOREDDATA"  // 重置储值数据
export const SETSTOREDDATA = "SETSTOREDDATA"   // 设置储值数据
export const SETSTOREDBALANCE = "SETSTOREDBALANCE"  // 设置储值余额
export const SETCARINFO = "SETCARINFO"   // 设置车辆信息
export const SETPARKINFO = "SETPARKINFO"   // 设置停车场信息
export const QUERYSTOREDCARS = "QUERYSTOREDCARS"  // 查询储值车辆列表
export const QUERYSTOREDPARKS = "QUERYSTOREDPARKS"  // 查询储值停车场列表
export const CREATESTOREDPAYORDER = "CREATESTOREDPAYORDER"  // 创建储值支付订单
export const GETSTOREDVALUE = "GETSTOREDVALUE"  // 获取储值余额
export const UPDATESTOREDBALANCE = "UPDATESTOREDBALANCE"  // 只更新储值余额，不重置其他数据


// WEBPACK FOOTER //
// ./src/store/stored/types.js